<template>
    <v-col
      cols="auto"
      v-for="element in elements"
      :key="element.id"
      style="padding: 1px; border-radius: 5px; cursor: pointer; margin-right: 2px"
      :class="getSelectedImage(element)"
      @click="$emit('modelLoaded', element)"
    >
      <v-img
        :src="element.image"
        :style="getWidth"
        style="border-radius: 5px"
      />
    </v-col>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'OptionsImages',
    props: {
      elements: Array,
      type: String,
    },

    emits: ["modelLoaded"],

    computed: {
      ...mapGetters(['isProductLoaded']),
      getWidth () {
        if(this.$vuetify.display.smAndDown) return 'width: 40px'
        return this.type === 'model' ? 'width: 80px' : 'width: 50px'

      }
    },

    methods: {
      getSelectedImage (element) {
        return (element.image && element.is_selected) ? 'v-img__active' : ''
      },
    }
  }
</script>
<style scoped>
.v-img__active {
  border: 2px solid #005686;
}
</style>
